/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateRescueRequest
 */
export interface CreateRescueRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateRescueRequest
     */
    newFirmwareId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRescueRequest
     */
    deviceTypeId: string;
}

export function CreateRescueRequestFromJSON(json: any): CreateRescueRequest {
    return CreateRescueRequestFromJSONTyped(json, false);
}

export function CreateRescueRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRescueRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'newFirmwareId': json['newFirmwareId'],
        'deviceTypeId': json['deviceTypeId'],
    };
}

export function CreateRescueRequestToJSON(value?: CreateRescueRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'newFirmwareId': value.newFirmwareId,
        'deviceTypeId': value.deviceTypeId,
    };
}

